type Entry = { users: number; retired: boolean }
const entries = new Map<string, Entry>()

const releaseIfUnused = (url: string, entry: Entry) => {
  // React StrictModeのcleanup直後の再取得にも猶予を与える。
  queueMicrotask(() => {
    if (entries.get(url) !== entry || !entry.retired || entry.users !== 0) return
    entries.delete(url)
    URL.revokeObjectURL(url)
  })
}

/** 作成者が所有し、loaderの実終了まで有効なObject URLを作る。 */
export const createManagedObjectUrl = (blob: Blob): string => {
  const url = URL.createObjectURL(blob)
  entries.set(url, { users: 0, retired: false })
  return url
}

/** 外部から渡されたURLの所有権は取得しない。返す関数はロード終了時に呼ぶ。 */
export const retainManagedObjectUrl = (url: string): (() => void) => {
  const entry = entries.get(url)
  if (!entry) return () => undefined
  entry.users += 1
  let released = false
  return () => {
    if (released) return
    released = true
    entry.users -= 1
    releaseIfUnused(url, entry)
  }
}

export const retireManagedObjectUrl = (url: string): void => {
  const entry = entries.get(url)
  if (!entry) return
  entry.retired = true
  releaseIfUnused(url, entry)
}
